import { render, staticRenderFns } from "./MainColumns .vue?vue&type=template&id=664a767b&scoped=true&"
import script from "./MainColumns .vue?vue&type=script&lang=js&"
export * from "./MainColumns .vue?vue&type=script&lang=js&"
import style0 from "./MainColumns .vue?vue&type=style&index=0&id=664a767b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a767b",
  null
  
)

export default component.exports